module.exports = "/images/vendor/desiigner-svg/svg/places/food-n-drink.svg?a414d40a19431466da7f77de30e0faf0";